// extracted by mini-css-extract-plugin
export default {"wrapper":"FeeWrapper_wrapper__mjI0f"};